import {useGetIdentity} from '@refinedev/core';
import {useDocumentTitle} from '@refinedev/react-router';

import {User} from '@app/types';

export const Home = () => {
  useDocumentTitle('documentTitle.dashboard');
  const {data: user} = useGetIdentity<User>();
  return (
    <>
      <h1>Bonjour {user?.given_name}</h1>
    </>
  );
};
